import React from 'react'
import {HiOutlineMail} from 'react-icons/hi'
import {AiOutlinePhone} from 'react-icons/ai'

function Footer() {
  return (
   <div className='max-w-[1240px] mx-auto pt-10 pb-20 text-center'>
        <h2 className='justify-center flex font-bold text-2xl md:text-4xl pb-8'>Skontaktuj się z nami</h2>
        <div className='justify-center mx-auto gap-2 grid grid-cols-1 md:grid-cols-2 md:place-items-center md:px-20'>
            <div className='px-20 '>
                <h3 className='font-semibold flex'>Krzysztof Sikora</h3>
                <div className='flex items-center'>
                    <HiOutlineMail size={30} className='mr-2 my-2'/>
                    <p>krzystof.sikora@oniko.pl</p>
                </div>
                <div className='flex items-center'>
                    <AiOutlinePhone size={30} className='mr-2'/>
                    <p>530-750-047</p>
                </div>
            </div>
            <div className='px-20 pt-10 md:pt-0'>
                <h3 className='font-semibold flex'>Łukasz Onichimowski</h3>
                <div className='flex items-center'>
                    <HiOutlineMail size={30} className='mr-2 my-2'/>
                    <p>lukasz.onichimowski@oniko.pl</p>
                </div>
                <div className='flex items-center'>
                    <AiOutlinePhone size={30} className='mr-2'/>
                    <p>530 750 124</p>
                </div>
            </div>
        </div>
   </div>
  )
}

export default Footer